export default "__VITE_ASSET__CNYuBabq__"